import { combineReducers } from "redux";
import helperReducer from "./helperReducer";

export default combineReducers({
    helpers: helperReducer,
})